import { API } from '../../providers/ApiInterceptorProvider';
import { BrokerOnboarding, BrokerPatchAddressPayload } from './types';

export const brokerApi = {
  getOnboarding: async (): Promise<BrokerOnboarding> => {
    const { data } = await API.get<BrokerOnboarding>(`/monolith/broker/onboarding`);
    return data;
  },

  patchBroker: async (payload: BrokerPatchAddressPayload): Promise<void> => {
    await API.patch(`/monolith/broker/me`, payload);
  },
};
